import Icon from "./IconBase.js";
const ArrowUpRight = (props) => {
  return (
    <Icon width="20" height="20" viewBox="0 0 20 20" {...props}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7 17L17 7"
          stroke="#00B0F5"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7 7H17V17"
          stroke="#00B0F5"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Icon>
  );
};
export default ArrowUpRight;
